import { lazy, Suspense } from "react";

import { Skeleton } from "@/components/ui/skeleton";

/** 図は出すときだけ読み込む（bpmn-js は重い）。 */
const BpmnViewer = lazy(() =>
  import("@/features/case-diagram/bpmn-viewer").then((m) => ({
    default: m.BpmnViewer,
  })),
);

/** 印（現在地・完了）は付けない。モジュール定数にして描画のやり直しを防ぐ。 */
const NO_MARKS = { current: [], completed: [], error: [] } as const;

/**
 * 持ち込んだ BPMN の図を、作成・取り込みの前に見せる。
 *
 * 一番多い失敗はファイルの選び間違い（別のモデルの書き出し、古い版など）で、
 * 図を見れば一目で分かる。描けたら onRendered、描けなかったら onRenderError で知らせる。
 */
export function BpmnPreview({
  xml,
  label,
  onRendered,
  onRenderError,
}: {
  readonly xml: string;
  readonly label: string;
  readonly onRendered?: () => void;
  readonly onRenderError?: () => void;
}) {
  return (
    <figure className="m-0 flex flex-col gap-1">
      <figcaption className="text-muted-foreground text-xs">{label}</figcaption>
      <Suspense fallback={<Skeleton className="h-56 w-full" />}>
        <BpmnViewer
          xml={xml}
          marks={NO_MARKS}
          className="border-border h-56 w-full rounded-md border"
          {...(onRendered === undefined ? {} : { onRendered })}
          {...(onRenderError === undefined ? {} : { onRenderError })}
        />
      </Suspense>
    </figure>
  );
}
